var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSemanticMetrics, createUniversalReporter, MetricTypes, Time, Timer, } from '@spotify-internal/semantic-metrics';
import { isDev } from './environment';
const { sendMetric } = createSemanticMetrics({
    dev: isDev,
    reporter: createUniversalReporter(),
    component_id: 'pillow-talk',
});
const counter = (what, value = 1, tags) => sendMetric({
    metric_type: MetricTypes.COUNTER,
    key: 'pillow-talk',
    what,
    value,
    tags,
});
const gauge = (what, value, tags) => sendMetric({
    metric_type: MetricTypes.GAUGE,
    key: 'pillow-talk',
    what,
    value,
    tags,
});
const timer = (what, value, tags) => sendMetric({
    metric_type: MetricTypes.TIMER,
    key: 'pillow-talk',
    what,
    value: value.asNanos(),
    tags,
});
const withReportLatency = (what, fn, lineOfBusiness) => __awaiter(void 0, void 0, void 0, function* () {
    const tick = Timer.start();
    try {
        const result = yield fn();
        yield timer(what, Time.fromNanos(tick.end().nanoseconds), {
            promiseFulfilled: 'true',
            lineOfBusiness: lineOfBusiness,
        });
        return result;
    }
    catch (exc) {
        yield timer(what, Time.fromNanos(tick.end().nanoseconds), {
            promiseRejected: 'true',
            lineOfBusiness: lineOfBusiness,
        });
        throw exc;
    }
});
export const createCaseCounter = (lineOfBusiness) => counter('create-case', 1, { lineOfBusiness: lineOfBusiness });
export const createCaseSuccess = (lineOfBusiness) => counter('create-case-success', 1, {
    lineOfBusiness: lineOfBusiness,
});
export const imageSize = (lineOfBusiness, size) => gauge('image-size', size, { lineOfBusiness: lineOfBusiness });
export const withCreateCaseLatency = (lineOfBusiness, fn) => withReportLatency('create-case-latency', fn, lineOfBusiness);
export const loginDialogResponse = (lineOfBusiness, choseToLogin) => counter('user-responded-login-dialog', 1, {
    choseToLogin: choseToLogin === 'login' ? 'true' : 'false',
    lineOfBusiness: lineOfBusiness,
});
export const errorBannerCounter = (lineOfBusiness, reason) => counter('error-banner-counter', 1, {
    reason: reason,
    lineOfBusiness: lineOfBusiness,
});
//# sourceMappingURL=metrics.js.map